<template>
  <div class="xpCard card">
    <div class="xp-card-info">
      <h1>{{ data.name }}</h1>
      <h2>{{ data.company }}</h2>
      <h3>
        <i class="fa fa-calendar fa-fw mini-icon" aria-hidden="true"></i>
        {{ data.date }}
      </h3>
      <h3>
        <i class="fa fa-map-marker fa-fw mini-icon" aria-hidden="true"></i>
        {{ data.place }}
      </h3>
    </div>
    <div class="xp-card-details">
      <p class="xp-card-desc">{{ data.description }}</p>
      <transition name="expand">
        <ul v-if="seeMore">
          <li v-for="dotPoint in data.details" :key="dotPoint" v-show="seeMore">
            {{ dotPoint }}
          </li>
        </ul>
      </transition>
      <div class="tag-container">
        <p class="pink-tag" v-for="tag in data.tags" :key="tag">{{ tag }}</p>
      </div>
      <div v-if="data.details.length > 0" class="see-more-container">
        <i
          class="see-more-btn fas fa-angle-down"
          v-show="!seeMore"
          @click="seeMore = !seeMore"
        ></i>
        <i
          class="see-more-btn fas fa-angle-up"
          v-show="seeMore"
          @click="seeMore = !seeMore"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExperienceCard",
  props: {
    data: null
  },
  data() {
    return {
      seeMore: false
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/_media_sizes.scss";
@import "@/assets/_colours.scss";
@import "@/assets/_font.scss";

.xpCard {
  .expand-enter-active {
    animation: expand 0.3s reverse;
  }
  .expand-leave-active {
    animation: expand 0.3s;
  }

  @keyframes expand {
    0% {
      max-height: 500px;
      opacity: 1;
    }
    100% {
      max-height: 0;
      opacity: 0;
    }
  }

  display: flex;
  flex-direction: column;
  max-width: 1000px;
  width: 100%;
  padding: 20px;
  border-radius: 10px;
  background-color: white;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.15);
  margin: 0 auto;
  margin-bottom: 40px;
  border: 1px solid #dadce0;

  @media only screen and (min-width: $tablet-potrait) {
    padding: 20px 30px;
  }

  h1 {
    font-size: $font-L;
    font-weight: bold;
    color: black;
    position: relative;
    margin-bottom: 5px;
    font-family: "Roboto", sans-serif;

    @media only screen and (max-width: $tablet-potrait) {
      font-size: $font-M;
    }
  }

  h2 {
    font-size: $font-M;
    font-weight: 400;
    color: $dark-grey;
    margin-top: 5px;
    font-family: "Roboto", sans-serif;

    @media only screen and (max-width: $tablet-potrait) {
      font-size: $font-S;
    }
  }

  h3 {
    font-size: $font-XS;
    font-weight: 400;
    color: $dark-grey;
    margin: 0.5em 0 0.5em 0;
  }

  ul {
    margin: 0 0 10px 0;
    transition: all 0.3s;
    color: $text-grey;
  }

  li {
    @media only screen and (max-width: $tablet-potrait) {
      margin-left: -1em;
    }
  }

  li {
    font-size: $font-XS;
    margin-left: -1em;
    margin-bottom: 5px;
  }

  .xp-card-desc {
    font-weight: 600;
  }

  .tag-container {
    margin: 10px 0;
  }

  .see-more-container {
    text-align: center;

    .see-more-btn {
      font-size: 30px;
      color: $light-grey;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 2em;
      width: 40px;
      height: 40px;
      transition: all 0.5s;
      border: solid 1px #ffffff00;

      &:hover {
        cursor: pointer;
        border: solid 1px $very-light-grey;
      }
    }
  }
}

@media only screen and (min-width: $desktop-lg) {
  .xpCard {
    display: grid;
    grid-template-columns: 275px 1fr;

    .xp-card-info {
      padding-right: 20px;
      border-right: 1px solid #e0e0e0;
      box-sizing: content-box;
    }

    .xp-card-details {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 5px 0 0 20px;
    }
  }
}
</style>
